import axios from 'axios';

export default {
    async list({ page }) {
        if (!page)
            page = 1;

        let response = await axios.get('/api/mailMessages', { params: { page } });
        return response.data;
    },
    async get(id) {
        id = parseInt(id);
        let response = await axios.get(`/api/mailMessages/${id}`);
        return response.data;
    },
    async retrieveNewMessages() {
        let response = await axios.post('/api/mailMessages/retrieveNewMessages');
        return response.data;
    },
};
